import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from './../../../assets/images/attachment.png'


const _hoisted_1 = { class: "gd-attachment mb-gutter" }
const _hoisted_2 = { class: "mb-gutter" }
const _hoisted_3 = { class: "gd-file-list font-small" }
const _hoisted_4 = { class: "list-styled" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "legal__attachment"
}, null, -1)
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "legal__attachmentlist" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", null, _toDisplayString(`${_ctx.translate("labeltext.partC")}${_ctx.translate(
            "labeltext.formCompletionHeader"
          )}`), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("ul", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newUser.DocumentList, (doc, index) => {
          return (_openBlock(), _createElementBlock("li", { key: index }, [
            _hoisted_5,
            _createElementVNode("a", {
              onClick: ($event: any) => (_ctx.downloadAttachments(doc.Guid, doc.FileLocation)),
              class: "legal__attachmentlist"
            }, [
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.getSelectedDocName(doc.DocumentTypeId)) + " - ", 1),
              _createTextVNode(" " + _toDisplayString(doc.FileLocation), 1)
            ], 8, _hoisted_6)
          ]))
        }), 128))
      ])
    ])
  ]))
}